import script from "./OSelecionarMembrosProjeto.vue?vue&type=script&lang=ts&setup=true"
export * from "./OSelecionarMembrosProjeto.vue?vue&type=script&lang=ts&setup=true"

import "./OSelecionarMembrosProjeto.vue?vue&type=style&index=0&id=d584d2be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d584d2be"]])

export default __exports__